'use strict';

/**
 * `realtime` service
 */
export default function realtime($rootScope, $ocLazyLoad, $injector, config, session, admin, development) {
  'ngInject';

  var socket;
  var ioSocket;

  /**
   * Returns query string needed for handshake authorization.
   * @returns {string}
   */
  function getQuery() {
    return 'token=' + session.get().accessToken;
  }

  return {

    init: function () {
      $rootScope.$on('userModel:initialized', () => {
        if (!admin.isAdmin() || development.check()) {
          try {
            require(['socket.io',
              'exports-loader?\'btford.socket-io\'!angular-socket-io'], (io, angularSocket) => {
              $ocLazyLoad.load({
                name: angularSocket
              }).then(() => {
                var socketFactory = $injector.get('socketFactory');
                this.connect(io, socketFactory);
              });
            });
          } catch (e){}
        }
      });
    },

    /**
     * Connects to socket io server or updates query and reconnects, if already connected.
     *
     */
    connect: function connect(io, socketFactory) {
      var options = {
        query: getQuery()
      };

      if (!socket) {
        ioSocket = io.connect(config.socketUrl, options);
        socket = socketFactory({
          ioSocket: ioSocket
        });

        EVENTS.forEach(eventName => {
          socket.forward(eventName);
        });

        DEFAULT_EVENTS.forEach(eventName => {
          this.startListeningTo(eventName);
        });
      }
    },

    /**
     * @param {String} eventType
     * @param {Object} [data]
     */
    startListeningTo: function startListeningTo(eventType, data) {
      if (socket) {
        socket.emit('startListening', angular.extend({ eventType: eventType }, data));
      }
    },

    /**
     * @param {String} eventType
     * @param {Object} [data]
     */
    stopListeningTo: function stopListeningTo(eventType, data) {
      if (socket) {
        socket.emit('stopListening', angular.extend({ eventType: eventType }, data));
      }
    },

    isTyping(userId) {
      if (socket) {
        socket.emit('typing', {converserId: userId});
      }
    },
  };
}

const EVENTS = [
  'unreadConversationId',
  'unreadConversation',
  'newMessage',
  'typing',
  'updates',
];
const DEFAULT_EVENTS = [
  'unreadConversationId'
];



// WEBPACK FOOTER //
// ./app/src/services/realtime.js